const TIMEOUT_CODES = ['ESOCKETTIMEDOUT', 'ETIMEDOUT']

export const isTimeoutError = (e: unknown) => {
  const { code } = (e ?? {}) as { code?: string }
  return !!code && TIMEOUT_CODES.includes(code)
}

export const isTransportError = (e: unknown) => {
  const { isNetworkError } = (e ?? {}) as { isNetworkError?: boolean }
  return !!isNetworkError || isTimeoutError(e)
}
